import router from './router'
import store from './store'
import {getUserInfos} from 'utils/cache'
// function hasPermission (roles, permissionRoles) {
//   if (roles.indexOf('admin') >= 0) return true // admin permission passed directly
//   if (!permissionRoles) return true
//   return roles.some(role => permissionRoles.indexOf(role) >= 0)
// }
// function retryGetMessage () {
//   setTimeout(() => {
//     store.dispatch('getMessageGlobal', {typeId: 0}).then((res) => {
//       retryGetMessage()
//     })
//   }, 10 * 1000)
// }
let ajaxState = false
let timer = 0
const whiteList = ['/login', '/reset']
router.beforeEach((to, from, next) => {
  if (store.getters.token) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      if (store.getters.roles.length === 0) {
        store.dispatch('getMessageGlobal', {typeId: 0})
        // retryGetMessage()
        timer = setInterval(() => {
          if (ajaxState) {
            clearInterval(timer)
            return
          }
          store.dispatch('getMessageGlobal', {typeId: 0}).catch(() => {
            console.log(123)
            ajaxState = true
          })
        }, 10000)
        store.dispatch('getUsersRoles', JSON.parse(getUserInfos())).then((roles) => {
          store.dispatch('generateRoutes', roles.role).then(() => { // 根据roles权限生成可访问的路由表
            router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
            next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
          })
        })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login`) // 否则全部重定向到登录页
    }
  }
})
router.afterEach(() => {
  // NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js